import { Image } from "react-bootstrap"

export const Footer = () => {
  return (
    <div className="footer">
      <div
        className="footer-content"
        style={{
          overflow: "hidden",
          backgroundColor: "#743d90",
          color: "white",
        }}
      >
        <div className="container">
          <div className="footerrow row ">
            <div className="col-12 col-md-12 col-xl-6">
              <div
                className="title-foot"
                style={{
                  marginTop: "20px",
                }}
              >
                <h3
                  style={{
                    color: "#fff",
                    textAlign: "left",
                    borderBottom: "1px solid #865d9b",
                    marginBottom: "10px",
                  }}
                >
                  ขอเชิญร่วมบริจาคผ่านช่องทางต่างๆ
                </h3>
              </div>
              <div className="text-center mt-3 ">
                <div className="banktxt row justify-content-between">
                  <div className="col-12 col-md-4 px-xl-0 mb-3">
                    <div
                      className="app-pay"
                      style={{
                        border: "1px solid #fff",
                        borderRadius: "20px",
                        padding: "10px",
                        backgroundColor: "#65318f",
                        paddingBottom: "20px",
                      }}
                    >
                      <div
                        className="app-pay_title head-apppay"
                        style={{
                          borderBottom: "1px solid #865d9b",
                          marginBottom: "10px",
                        }}
                      >
                        <h3>โอนเงิน</h3>
                        <div>
                          ชื่อบัญชี มูลนิธิโรงพยาบาลนครพิงค์
                          <br />
                          สาขา แม่ริม
                        </div>
                      </div>
                      <div className="app-pay_image">
                        <Image fluid src="images/footer-ktb.png" />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 col-xl-3 px-xl-0 mb-3">
                    <h5>สแกนผ่านแอปฯ ธนาคาร</h5>
                    <a href="images/qrPay.jpg" target="_blank">
                      <Image rounded fluid src="images/qrPay.jpg" />
                    </a>
                  </div>
                  <div className="col-12 col-md-4 col-xl-3 px-xl-0">
                    <h5>จุดรับบริจาค และจำหน่ายของที่ระลึก</h5>
                    <Image
                      width={"100%"}
                      loading="lazy"
                      fluid
                      src={`images/image-place-1-600xauto.jpg`}
                      alt={""}
                    />
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1587.523510912479!2d98.96839055753817!3d18.852069260660652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sth!2sth!4v1674710203248!5m2!1sth!2sth"
                      width="100%"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                    <p>
                      สำนักงานมูลนิธิโรงพยาบาลนครพิงค์ <br />
                      อาคาร 3 (ผู้ป่วยนอก) ชัน 1
                    </p>
                  </div>
                </div>
              </div>
              <div className="title-foot">
                <h4
                  style={{
                    marginTop: "20px",
                    color: "#fff",
                    textAlign: "left",
                    borderBottom: "1px solid #865d9b",
                    marginBottom: "10px",
                  }}
                >
                  ติดต่อเรา
                </h4>
              </div>
              <div className="contacttxt row">
                <div className="col-12">
                  <p className="text-uppercase mb-0">
                    มูลนิธิโรงพยาบาลนครพิงค์
                  </p>
                  <p className="mb-xl-3">
                    โรงพยาบาลนครพิงค์ 159 หมู่ที่ 10 ถนนโชตนา ตำบลดอนแก้ว
                    อำเภอแม่ริม จังหวัดเชียงใหม่ 50180
                  </p>
                  <p>☎️ ติดต่อสอบถาม : 082 280 4022</p>
                </div>
              </div>
              <div className="followus-txt mb-4">
                <p>
                  ติดตามข่าวสารเพิ่มเติมได้ที่ :{" "}
                  <a
                    href="https://www.facebook.com/profile.php?id=100089473187886"
                    target="_blank"
                  >
                    <img
                      className="img-fb  hvr-pulse grow"
                      src="images/logo-fbnew.png"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footerbuttom">
          {/* <div className="container">
            <div className="footerrow row justify-content-center">
              <div className="col-12">
                <div className="row justify-content-center">
                  <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                    <div
                      className="row justify-content-between"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="footercol col-12 col-md-3 col-lg-3 ">
                        <div className="download-conten " id="emailhover">
                          <a
                            href="mailto:info@ramafoundation.or.th"
                            target="_self"
                          >
                            <img src="assets/images/img-email.png" />
                          </a>
                          <div className="">
                            <p>อีเมลติดต่อสอบถาม</p>
                            <p className="email_text">
                              info@ramafoundation.or.th
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="footercol col-12 col-md-3 col-lg-3 ">
                        <div className="download-conten" id="phonehover">
                          <a href="tel:+022011111" target="_self">
                            <img src="assets/images/img-phone.png" />
                          </a>
                          <p>
                            สอบถามข้อมูลโทร
                            <br />
                            0-2201-1111
                          </p>
                        </div>
                      </div>
                      <div className="footercol col-12 col-md-3 col-lg-3 ">
                        <div className="download-conten" id="gifthover">
                          <a
                            href="https://www.ramafoundation.or.th/donat_benefits"
                            target="_self"
                          >
                            <img src="assets/images/img-gift.png" />
                          </a>
                          <p>สิทธิประโยชน์</p>
                        </div>
                      </div>
                      <div className="footercol col-12 col-md-3 col-lg-3 ">
                        <div className="download-conten" id="addresshover">
                          <a
                            href="https://www.ramafoundation.or.th/contact"
                            target="_self"
                          >
                            <img src="assets/images/img-address.png" />
                          </a>
                          <p>การติดต่อมูลนิธิ</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="copyright">
            <div className="container">
              <div className="row justify-content-center">
                <div
                  className="col-12  col-xl-12"
                  style={{ borderTop: "1px solid" }}
                >
                  <div className="copyright-txt">
                    <p>
                      2019 © RAMATHIBODI FOUNDATION. All Rights Reserved |
                      Privacy Policy
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}
